import { SvgDownload, SvgExternalLink, SvgShare } from '@loomhq/lens';
import React from 'react';

import { openModal } from 'actions/modals';
import { isDev } from 'constants/environment';
import * as menuOptions from 'constants/menuOptions';
import {
  DOWNLOAD_VIDEO_INFO_MODAL,
  SHARE_UI_MODAL,
} from 'constants/modalTypes';
import { LOOM_BARE_URI } from 'constants/routes';
import { SHOW_DOWNLOAD_VIDEO_INFO_MODAL } from 'constants/triggers';
import { ADMIN } from 'constants/userRoles';
import { PROFILE_CONTEXT } from 'constants/videoCard';
import { startDownload } from 'creators/header';
import { completeTriggerCreator } from 'creators/triggers';
import {
  MenuOption,
  OnClickParameters,
  ShowParameters,
} from 'utilities/menuOptions/types';

const DIVE: MenuOption = {
  key: menuOptions.DIVE,
  label: menuOptions.DIVE,
  icon: <SvgExternalLink />,
  onClick: ({ items }: OnClickParameters): void => {
    const url = `https://${LOOM_BARE_URI}/admin/videos/video-dive/${items[0].id}`;

    window.location.replace(url);
  },
  show: ({ items, currentUser, scopes }: ShowParameters) => {
    return (
      items.length === 1 &&
      items[0].__typename === 'RegularUserVideo' &&
      scopes.hasAuthenticatedAccess &&
      (currentUser.role === ADMIN || isDev)
    );
  },
};

const DOWNLOAD: MenuOption = {
  key: menuOptions.DOWNLOAD,
  label: menuOptions.DOWNLOAD,
  icon: <SvgDownload />,
  onClick: ({
    dispatch,
    items,
    extras,
    menuContext,
  }: OnClickParameters): void => {
    const item = items[0];

    if (item.__typename === 'RegularUserVideo') {
      const url = menuContext.downloadUrl || extras.downloadUrl;
      const downloadName = `${item.name || item.id}.mp4`;
      const downloadParams = {
        url,
        name: downloadName,
        opts: {
          video_id: item.id,
          is_owner: item.current_user_is_owner,
        },
      };

      if (extras.shouldShowDownloadInfoModal) {
        dispatch(openModal(DOWNLOAD_VIDEO_INFO_MODAL, downloadParams));
        dispatch(completeTriggerCreator(SHOW_DOWNLOAD_VIDEO_INFO_MODAL));
      } else {
        dispatch(startDownload(downloadParams));
      }
    }
  },
  show: ({ items, menuContext }: ShowParameters) => {
    return (
      menuContext.type !== PROFILE_CONTEXT &&
      items.length === 1 &&
      items.every(
        item =>
          item.__typename === 'RegularUserVideo' &&
          (item.currentUserCanEdit || item.download_enabled) &&
          !item.archived
      )
    );
  },
};

const SHARE: MenuOption = {
  key: menuOptions.SHARE,
  label: menuOptions.SHARE,
  icon: <SvgShare />,
  onClick: ({ dispatch, items }: OnClickParameters): void => {
    dispatch(
      openModal(SHARE_UI_MODAL, {
        video: items[0],
      })
    );
  },
  show: ({ items, scopes }: ShowParameters) => {
    return (
      scopes.hasAuthenticatedAccess &&
      items.length === 1 &&
      items.every(
        item => item.__typename === 'RegularUserVideo' && !item.archived
      )
    );
  },
};

export default {
  DIVE,
  DOWNLOAD,
  SHARE,
};
